module.exports = __webpack_public_path__ + "static/media/and_scr_success.6254e200.png";